export default "__VITE_PUBLIC_ASSET__7ba4b870__"